import { Image } from '@/components/HOC/Image'

import { Game } from 'types/types'

import MinesIcon from '@/public/assets/images/games-icons/mines-icon-96x96.png'
import JackpotIcon from '@/public/assets/images/games-icons/jackpot-icon-96x96.png'
import DoubleIcon from '@/public/assets/images/games-icons/double-icon-96x96.png'
import RunesIcon from '@/public/assets/images/games-icons/runes-icon-96x96.png'
import CoinflipIcon from '@/public/assets/images/games-icons/coinflip-icon-96x96.png'
import LootboxIcon from '@/public/assets/images/games-icons/lootbox-icon-96x96.png'
import PlinkoIcon from '@/public/assets/images/games-icons/plinko-icon-96x96.png'
import GameZoneIcon from '@/public/assets/images/games-icons/game-zone-icon-96x96.png'

export const sections = [
  {
    name: Game.DOUBLE,
    title: 'games.double',
    icon: <Image src={DoubleIcon} alt={''} />,
  },
  {
    name: Game.RUNES,
    title: 'games.runes',
    icon: <Image src={RunesIcon} alt={''} />,
  },
  {
    name: Game.COINFLIP,
    title: 'games.coinflip',
    icon: <Image src={CoinflipIcon} alt={''} />,
  },
  {
    name: Game.MINES,
    title: 'games.mines',
    icon: <Image src={MinesIcon} alt={''} />,
  },
  {
    name: Game.LOOTBOX,
    title: 'games.lootbox',
    icon: <Image src={LootboxIcon} alt={''} />,
  },
  {
    name: Game.JACKPOT,
    title: 'games.jackpot',
    icon: <Image src={JackpotIcon} alt={''} />,
  },
  {
    name: Game.PLINKO,
    title: 'games.plinko',
    icon: <Image src={PlinkoIcon} alt={''} />,
  },

  {
    name: Game.GAMEZONE,
    title: 'games.game_zone',
    icon: <Image src={GameZoneIcon} alt={''} />,
  },
]
